import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateService } from '../../date.service';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
})
export class DatepickerComponent {
  @Input() disabled: boolean = false;
  @Input() form!: FormControl;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;
  @Input() placeholder: string = '選択して下さい';
  @Output() formChange = new EventEmitter<FormControl>();
  get inputStyle() {
    if (this.disabled) {
      return { color: 'transparent' }
    }
    return {};
  }
  constructor(
    public dateService: DateService
  ) {
  }

  hasRangeError() {
    return (
      this.form.hasError('matDatepickerMin') ||
      this.form.hasError('matDatepickerMax')
    );
  }

  onChange(): void {
    this.formChange.emit(this.form);
  }
}
